import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import SsoCallback from "./pages/SsoCallback";
import RegisterInterest from "./pages/RegisterInterest";
import ResetPassword from "./pages/ResetPassword";
import ActivateAccount from "./pages/ActivateAccount";
import ApprovalPage from "./pages/ApprovalPage";
import Dashboard from "./pages/Dashboard";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import VehicleAvailability from "./pages/VehicleAvailability";
import MaintenanceRecords from "./pages/MaintenanceRecords";
import DisposalRecords from "./pages/DisposalRecords";
import DriverAvailability from "./pages/DriverAvailability";
import Bookings from "./pages/Bookings";
import NewBooking from "./pages/NewBooking";
import BookingDetail from "./pages/BookingDetail";
import Trips from "./pages/Trips";
import Refuels from "./pages/Refuels";
import RefuelForm from "./pages/RefuelForm";
import TripAction from "./pages/TripAction";
import TripDetail from "./pages/TripDetail";
import SettingsPage from "./pages/SettingsPage";
import ModulePage from "./pages/ModulePage";
import ReportsPage from "./pages/ReportsPage";
import ProfilePage from "./pages/ProfilePage";
import BukuLogPrint from "./pages/BukuLogPrint";
import JanaLaporan from "./pages/JanaLaporan";
import JanaLaporanPrint from "./pages/JanaLaporanPrint";
import JanaPenyelenggaraanPrint from "./pages/JanaPenyelenggaraanPrint";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Memuatkan...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function ProtectedBare({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Memuatkan...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/sso-callback" element={<SsoCallback />} />
      <Route path="/daftar" element={<RegisterInterest />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/aktifkan" element={<ActivateAccount />} />
      <Route path="/kelulusan" element={<ApprovalPage />} />
      <Route path="/laporan/buku-log" element={<Navigate to="/jana-laporan" replace />} />
      <Route path="/jana-laporan" element={<Protected roles={["admin", "operator"]}><JanaLaporan /></Protected>} />
      <Route path="/cetak/jana-laporan/:vehicleId" element={<ProtectedBare roles={["admin", "operator"]}><JanaLaporanPrint /></ProtectedBare>} />
      <Route path="/cetak/jana-penyelenggaraan/:vehicleId" element={<ProtectedBare roles={["admin", "operator"]}><JanaPenyelenggaraanPrint /></ProtectedBare>} />
      <Route path="/cetak/buku-log/:vehicleId" element={<ProtectedBare roles={["admin", "operator"]}><BukuLogPrint /></ProtectedBare>} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/kenderaan" element={<Protected roles={["admin", "operator"]}><Vehicles /></Protected>} />
      <Route path="/kenderaan/ketersediaan" element={<Protected roles={["admin", "operator"]}><VehicleAvailability /></Protected>} />
      <Route path="/kenderaan/penyelenggaraan" element={<Protected roles={["admin", "operator"]}><MaintenanceRecords /></Protected>} />
      <Route path="/kenderaan/pelupusan" element={<Protected roles={["admin", "operator"]}><DisposalRecords /></Protected>} />
      <Route path="/pemandu/ketersediaan" element={<Protected roles={["admin", "operator"]}><DriverAvailability /></Protected>} />
      <Route path="/kenderaan/:id" element={<Protected roles={["admin", "operator"]}><VehicleDetail /></Protected>} />
      <Route path="/tempahan" element={<Protected><Bookings /></Protected>} />
      <Route path="/tempahan/baharu" element={<Protected roles={["driver", "admin", "operator"]}><NewBooking /></Protected>} />
      <Route path="/tempahan/:id" element={<Protected><BookingDetail /></Protected>} />
      <Route path="/perjalanan/:bookingId" element={<Protected><TripAction /></Protected>} />
      <Route path="/log-perjalanan" element={<Protected><Trips /></Protected>} />
      <Route path="/isi-minyak" element={<Protected roles={["admin", "operator", "pemandu"]}><Refuels /></Protected>} />
      <Route path="/isi-minyak/baharu" element={<Protected roles={["pemandu", "admin", "operator"]}><RefuelForm /></Protected>} />
      <Route path="/log-perjalanan/:id" element={<Protected><TripDetail /></Protected>} />
      <Route path="/pengguna" element={<Navigate to="/tetapan/pengguna" replace />} />
      <Route path="/profil" element={<Protected><ProfilePage /></Protected>} />
      <Route path="/tetapan" element={<Protected roles={["admin"]}><SettingsPage /></Protected>} />
      <Route path="/tetapan/:section" element={<Protected roles={["admin"]}><SettingsPage /></Protected>} />
      <Route path="/tetapan/:section/:id" element={<Protected roles={["admin"]}><SettingsPage /></Protected>} />
      <Route path="/laporan" element={<Protected roles={["admin", "operator"]}><ReportsPage /></Protected>} />
      <Route path="/modul/:slug" element={<Protected roles={["admin", "operator"]}><ModulePage /></Protected>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
